module.exports = __webpack_public_path__ + "static/media/lessD.13eb2f82.png";